import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal newgame active"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h5", null, "Game erfassen", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_tickets_game_inputs = _resolveComponent("tickets-game-inputs")!

  return ($setup.game)
    ? (_openBlock(), _createElementBlock("dialog", _hoisted_1, [
        _hoisted_2,
        _createVNode(_component_tickets_game_inputs, {
          game: $setup.game,
          onSave: $setup.save,
          onCancel: $setup.cancel
        }, null, 8, ["game"])
      ]))
    : _createCommentVNode("", true)
}